const CLIENTE_IMPORTADOR = 'IMPORTADOR';
const CLIENTE_EXPORTADOR = 'EXPORTADOR';

const ClienteUtils = Object.freeze({
  IMPORTADOR: CLIENTE_IMPORTADOR,
  EXPORTADOR: CLIENTE_EXPORTADOR,
  AGENCIAMENTO_IMPORTADOR: 'AGENCIAMENTO_IMPORTADOR',
});

export {
  ClienteUtils,
  CLIENTE_EXPORTADOR,
  CLIENTE_IMPORTADOR,
};
